import "../Styles/WCAGSkipLinks.scss";

window.am = window.am || {};

window.am.wcagSkipLinks = new function () {
    var that = this;

    that.init = function () {
        var container = document.querySelector('.skip-links__container');

        if (container) {
            var links = container.querySelectorAll(".skip-links__target");

            links.forEach(function (link) {
                var id = link.attributes.href.value;

                var target = document.querySelector(id);

                if (target) {
                    link.addEventListener("focus", function () {
                        link.parentElement.classList.add("skip-links--show");
                    });

                    link.addEventListener("blur", function () {
                        link.parentElement.classList.remove("skip-links--show");
                    });
                } else {
                    link.style.display = "none";
                }
            });
        }
    };
};

window.am.wcagSkipLinks.init();